import { Button, Typography } from '@mui/material';

import { useTranslate } from '@/hooks/useTranslate.ts';

import { openRepublicSuperApp } from '@/utils/superApp';

import {
  FinishedLogo,
  StyledFinishedScreen,
} from '../mobile/create-new-account/CreateNewAccount.styled';

export default function SessionExpiredPage() {
  const { t } = useTranslate();

  return (
    <StyledFinishedScreen>
      <FinishedLogo />
      <Typography variant="h2" textAlign="center" mb={2}>
        {t('sessionExpired.header')}
      </Typography>
      <Typography variant="body2" textAlign="center" mb={4}>
        {t('sessionExpired.body')}
      </Typography>
      <Button
        onClick={openRepublicSuperApp}
        variant="contained"
        fullWidth
        sx={{ maxWidth: 360, alignSelf: 'center' }}
      >
        {t('sessionExpired.button.openBankingApp')}
      </Button>
    </StyledFinishedScreen>
  );
}
